export type PageSdkRequestTracker = {
  begin: () => () => void;
  getSnapshot: () => number;
  subscribe: (listener: () => void) => () => void;
};

/**
 * Counts imperative Page SDK requests that run outside React Query. A tracker
 * belongs to one rendered Page, so an old document cannot hold a later Page's
 * print readiness open.
 */
export function createPageSdkRequestTracker(): PageSdkRequestTracker {
  let pendingRequests = 0;
  const listeners = new Set<() => void>();

  const notify = () => {
    for (const listener of listeners) {
      listener();
    }
  };

  return {
    begin: () => {
      pendingRequests += 1;
      notify();

      let isPending = true;

      return () => {
        if (!isPending) {
          return;
        }

        isPending = false;
        pendingRequests -= 1;
        notify();
      };
    },
    getSnapshot: () => pendingRequests,
    subscribe: (listener) => {
      listeners.add(listener);

      return () => listeners.delete(listener);
    }
  };
}
